import { SCREENSHOT_PANEL_CLASS_NAME, Screenshot } from './Screenshot';
import { FOCUS_RING_CLASS_NAME } from './styles';
import type { SanityScreenshotsBlock } from '@lib/sanity/types';

const IMAGE_WIDTHS = [320, 480, 640, 960];
const IMAGE_DEFAULT_WIDTH = 640;
const IMAGE_SIZES = {
  phone: '190px',
  wide: '(min-width: 40rem) 300px, 70vw'
};

/**
 * Screenshots side by side on the update's panel colour. On a phone the row
 * scrolls sideways a screenshot at a time, with the next one peeking in so it
 * is clear there is more.
 */
export const ScreenshotsBlock = ({
  value
}: {
  value: SanityScreenshotsBlock;
}) => {
  const images = (value.images ?? []).filter((image) => image.asset);
  if (images.length === 0) return null;

  return (
    <div
      className={`not-prose my-8 rounded-xl py-4 ${SCREENSHOT_PANEL_CLASS_NAME}`}
      data-cy="screenshots-block"
    >
      {/* Scrolls on a phone, so it takes focus for keyboard scrolling. */}
      <div
        role="group"
        aria-label="Screenshots"
        tabIndex={0}
        className={`flex snap-x snap-mandatory scroll-px-6 gap-5 overflow-x-auto px-6 py-4 sm:justify-center sm:px-8 ${FOCUS_RING_CLASS_NAME}`}
      >
        {images.map((image) => (
          <figure
            key={image._key}
            className="m-0 flex shrink-0 basis-[70%] snap-center flex-col items-center gap-3 sm:shrink sm:basis-0 sm:flex-1"
          >
            <Screenshot
              image={image}
              scale="card"
              widths={IMAGE_WIDTHS}
              defaultWidth={IMAGE_DEFAULT_WIDTH}
              sizes={IMAGE_SIZES}
              maxHeightClassName="[--screenshot-max-height:420px]"
              loading="lazy"
            />
            {image.caption && (
              <figcaption className="text-center font-body text-[13px] leading-[1.45] text-landing-slate">
                {image.caption}
              </figcaption>
            )}
          </figure>
        ))}
      </div>
    </div>
  );
};
